import axios from 'axios';
import Vue from 'vue';
import StoryPopup from '../components/StoryPopup';

const url = process.env.VUE_APP_API_URI;

const openPopup = (id) => {
    return new Promise((resolve, reject) => {
        const query = { query: `query { story(id: "${id}") { id name title mainImageUrl content description publishDate author { firstName lastName screenName } }}` };
        axios.post(url, query,
            {
                headers: {
                    "X-API-Key": process.env.VUE_APP_API_KEY
                }
            })
            .then(res => {
                const story = res.data.data.story;
                const PopupClass = Vue.extend(StoryPopup);
                let popup = new PopupClass({
                    propsData: {
                        story
                    }
                });
                popup.$on('close', () => {
                    document.querySelector("#app").removeChild(popup.$el);
                    popup.$destroy();
                    popup = null;
                });
                popup.$mount();
                document.querySelector('#app').appendChild(popup.$el);
                resolve(popup);
            })
            .catch(reject);
    });
}

export default {
    openPopup
};